// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import io from 'socket.io-client'
import { useRuntimeConfig } from '#app'

export default defineNuxtPlugin(() => {
  const environment = useRuntimeConfig()
  const socketUrl = environment.public.SOCKET_URL
  const eio = io(socketUrl, {})
  return {
    provide: {
      io: eio
    }
  }
})
